import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../config.js';

import Modal from './../../components/modal.js';
import Loading from './../../components/loading.js';
import Dropdown from './../../components/dropdown.js';
import Actionsheets from './../../components/actionsheets.js';
import Subject from './uncategorized/subject.js';
import SubjectArchive from './uncategorized/subject_archive.js';

import Editsubject from './uncategorized/edit_subject.js';
import Tagsubject from './uncategorized/tag_subject.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class Projectgroup extends React.Component {
	constructor(props) {
		super(props);
		let user = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}
		//console.log(props)
		let uistyle = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
			if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
				uistyle = JSON.parse(user.company.type);
			}
		}
		const projectid = props.project.id;
		const data_type = props.project.data_type; //0 or archive [modality]
		const pathurl = props.project.pathurl;
		const search = props.project.search;
		let groups = props.project.groups || [];
		//console.log(groups)
		this.state = {
			search: search,
			pathurl: pathurl,
			user: user,
			projectid: projectid,
			data_type: data_type,
			//isrequest:true,
			groups: groups,
			loading: false,
			ismodal: false,
			modaltitle: '',
			edit_type: 'editgroup',
			groupname: '',
			groupid: 0,
			isaction: false,
			subject_id: 0,
			subject_name: '',
			subject_age: 50,
			subject_explain: '',
			subject_gender: '',
			subject_uid: '',
			subject_userid: '',
			filestyle: {
				doc: 'far fa-file-word',
				docx: 'far fa-file-word',
				ppt: 'far fa-file-powerpoint',
				pptx: 'far fa-file-powerpoint',
				xls: 'far fa-file-excel',
				xlsx: 'far fa-file-excel',
				pdf: 'far fa-file-pdf',
				mp3: 'far fa-file-audio',
				mp4: 'far fa-file-movie',
				png: 'far fa-file-image',
				jpg: 'far fa-file-image',
				jepg: 'far fa-file-image',
				zip: 'far fa-file-zip',
				rar: 'far fa-file-zip',
				file: 'far fa-file-archive'
			},
			tasks: [],
			ismodal_download: false,
			downloadurl: '',
			download_message: '',
			checked_subjects: [],
			prototype: [],
			ismodal_changegroup: false,
			changegroupid: 0,
			uistyle: uistyle,
			tagids: [],
			tagname: ''
		}

		this.modalClose = this.modalClose.bind(this);
		this.modalSubmit = this.modalSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.actionClose = this.actionClose.bind(this);
		this.actionSubmit = this.actionSubmit.bind(this);
		this.sync = this.sync.bind(this);
		this.changeGroup = this.changeGroup.bind(this);


	}

	componentWillReceiveProps(nextProps) {
		const self = this;
		const data_type = nextProps.project.data_type;
		const isrequest = self.state.data_type !== nextProps.project.data_type || nextProps.project.isrequest ? true : false;
		//self.state.isrequest = nextProps.project.isrequest;
		//self.state.data_type = nextProps.project.data_type;

		self.setState({
			groups: nextProps.project.groups || [],
			data_type: nextProps.project.data_type,
			search: nextProps.project.search,
			isrequest: isrequest
		});

		//isrequest ? this.onInitial(data_type) : null;
	}

	componentDidMount() {
		this.sync();
		//this.getPrototype();
	}



	sync() {
		const data_type = this.props.project.data_type;
		//this.convert_task();
		//this.onInitial(data_type);
		this.project_tasks();
	}


	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}


	project_tasks() { //which upload just now and status is 0
		const me = this;
		const postdata = {
			userid: me.state.user.id,
			projectid: me.state.projectid,
			companyid: me.state.user.company_id,
			Authorization: localStorage.token,
			request: 'project_tasks'
		};
		fetch(config.host + '/project/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			}).then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						tasks: json.data
					});
				} else {
					me.setState({
						tasks: []
					});
				}
			});
	}


	convert_task() {
		const me = this;
		const postdata = {
			userid: me.state.user.id,
			projectid: me.state.projectid,
			Authorization: localStorage.token,
			request: 'convert_task'
		};
		fetch(config.host + '/project_group/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		});
	}



	showsubject(groupid) {
		const me = this;
		let groups = me.state.groups;
		groups.map((g, i) => {
			if (g.id === groupid) {
				g.showsubjects = !g.showsubjects
			}
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
	}



	showfile(groupid, subjectid) {
		const me = this;
		let groups = me.state.groups;
		groups.map((g, i) => {
			if (g.id === groupid) {
				g.subjects.data.map((s, i) => {
					if (s.id === subjectid) {
						s.showfiles = !s.showfiles;
					}
				});
			}
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups
		});
		return;
	}



	control_file_checkbox(item) {
		// if (typeof(item.task) !== 'undefined' && item.task.length) {
		// 	item.task.map((t, n) => {
		// 		if (t.files.length) {
		// 			t.files.map((f, m) => {
		// 				f.checked = item.checked;
		// 			})
		// 		}

		// 	});
		// }
		if (typeof(item.head) !== 'undefined' && item.head.length) {
			item.head.map((t, n) => {
				if (t.files.length) {
					t.files.map((f, m) => {
						f.checked = item.checked;
					})
				}
			});
		}
	}


	checkgroup(groupid) {
		const me = this;
		let {
			groups,
			checked_subjects
		} = me.state;
		groups.map(function(g, i) {
			if (g.id === groupid) {
				g.checked = !g.checked;
				if (g.subjects.total) {
					g.subjects.data.map((item, i) => {
						item.checked = g.checked;
						if (item.checked) {
							checked_subjects.push(item.id);
						} else {
							checked_subjects = checked_subjects.filter((ft) => {
								return ft !== item.id
							});
						}
						me.control_file_checkbox(item);
					});
				}
				g.checkedsubject = g.checked ? g.subjects.total : 0;
			}
		});
		groups = Object.assign(me.state.groups, groups)
		me.setState({
			groups: groups,
			loading: false,
			checked_subjects: checked_subjects
		});

	}


	checksubject(subject) {
		//console.log(subject.attribute_id);

		const me = this;
		const groupid = subject.attribute_id;
		const subjectid = subject.id;
		let {
			groups,
			checked_subjects
		} = me.state;
		groups.map(function(g, i) {
			if (g.id === groupid && g.subjects.total) {
				g.subjects.data.map((item, i) => {
					if (item.id === subjectid) {
						item.checked = !item.checked;
						if (item.checked) {
							checked_subjects.push(item.id);
						} else {
							checked_subjects = checked_subjects.filter((ft) => {
								return ft !== item.id
							});
						}
						me.control_file_checkbox(item);
						g.checkedsubject = item.checked ? g.checkedsubject + 1 : g.checkedsubject - 1;
					}
				});
				groups[i].checked = g.checkedsubject > 0;
				//groups[i].checked = (g.checkedsubject > 0) ? true : g.checked;
				//groups[i].checked = g.checkedsubject === 0 ? false : g.checked;
			}
		});
		groups = Object.assign(me.state.groups, groups);
		me.setState({
			groups: groups,
			loading: false,
			checked_subjects: checked_subjects
		});

	}

	props_check_subject(subject) {
		console.log(subject.attribute_id)
		this.checksubject(subject)

	}



	handleInputChange(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		const type = target.type;

		let tagids = me.state.tagids;
		if (type == "checkbox" && name == "tagid") {

			if (tagids.indexOf(value) >= 0) {
				tagids = tagids.filter((ft) => {
					return ft !== value
				});
			} else {
				tagids.push(value);
			}

			me.setState({
				tagids: tagids
			})
		} else {

			me.setState({
				[name]: value
			})
		}
	}


	modalClose() {
		this.setState({
			ismodal: false,
			loading: false,
			ismodal_download: false,
			ismodal_changegroup: false,
			tagids: [],
			tagname: ''
		})
	}


	trim(str) {
		return str.replace(/(^\s*)|(\s*$)/g, "");
	}


	modalSubmit() {
		const me = this;
		const {
			edit_type,
			groupname,
			subject_name,
			subject_age,
			tagids,
			tagname
		} = me.state;
		if (edit_type === 'editgroup') {
			if (me.trim(groupname) === '') {
				me.notify('分组名称不能为空');
				return;
			}
		}
		if (edit_type === 'editsubject') {
			if (me.trim(subject_name) === '') {
				me.notify('受试者编号不能为空');
				return;
			}
			if (subject_age.length > 8) {
				me.notify('受试者年龄须为数值');
				return;
			}
		}

		me.postModal();
	}


	modalGroup(group) {
		const me = this;
		me.setState({
			ismodal: true,
			edit_type: 'editgroup',
			modaltitle: '编辑分组',
			groupid: group.id,
			groupname: group.name
		})
	}


	removeGroup(groupid) {
		this.setState({
			groupid: groupid,
			edit_type: 'removegroup',
			isaction: true
		})
	}


	modalSubject(subject, edit_type) {
		console.log(subject.attribute_id)
		if (edit_type === 'editsubject') {
			this.setState({
				ismodal: true,
				edit_type: 'editsubject',
				modaltitle: '修改受试者信息',
				groupid: subject.attribute_id,
				subject_id: subject.id,
				subject_name: subject.subject_name,
				subject_age: subject.subject_age,
				subject_gender: subject.subject_gender,
				subject_explain: subject.subject_explain || '',
				subject_uid: subject.subject_uid
			});
		}


		if (edit_type === 'tagsubject') {

			let subject_tagids = [];
			if (subject.tags.length) {
				subject.tags.map((t, i) => {
					subject_tagids.push(t.id);
				})
			}
			this.setState({
				ismodal: true,
				edit_type: edit_type,
				modaltitle: '设置标签',
				groupid: subject.attribute_id,
				subject_id: subject.id,
				subject_userid: subject.user_id,
				subject_tags: subject.tags,
				tagids: subject_tagids
			})
		}
	}


	removeSubject(subject) {
		this.setState({
			groupid: subject.attribute_id,
			subject_id: subject.id,
			edit_type: 'removesubject',
			isaction: true
		})
	}

	refreshGroup() {
		const me = this;
		let {
			groups,
			groupid,
			groupname,
			edit_type,
			subject_id,
			subject_age,
			subject_name,
			subject_gender,
			subject_uid,
			subject_explain,
			data_type
		} = me.state;
		if (!groups.length) {
			//console.log('here');
			//me.onInitial(data_type);
			return;
		}
		switch (edit_type) {
			case 'editgroup':
				groups.forEach(g => {
					if (g.id === groupid) {
						g.name = groupname
					}
					return g;
				});
				break;
			case 'removegroup':
				groups.map((g, i) => {
					if (g.id === groupid) {
						groups.splice(i, 1);
					}
				});
				break;
			case 'editsubject':
				groups.forEach(g => {
					if (g.id === groupid) {
						g.subjects.data.forEach(s => {
							if (s.id === subject_id) {
								s.subject_age = subject_age;
								s.subject_name = subject_name;
								s.subject_gender = subject_gender;
								s.subject_uid = subject_uid;
								s.subject_explain = subject_explain;
							}
						})
					}
					return g;
				});
				break;

			case 'removesubject':
				groups.forEach(g => {
					if (g.id === groupid) {
						g.subjects.data.map((s, i) => {
							if (s.id === subject_id) {
								g.subjects.data.splice(i, 1);
							}
						})
					}
					return g;
				});
				break;
			default:
		}
		me.setState({
			groups: groups
		});
	}



	reloadSubjectTags(tags) {
		const me = this;
		let {
			groups,
			subject_id,
			groupid
		} = me.state;
		groups.forEach(g => {
			if (g.id === groupid) {
				g.subjects.data.forEach(s => {
					if (s.id === subject_id) {
						s.tags = tags;
					}
				})
			}
			return g;
		});
		me.setState({
			groups: groups
		});
	}

	actionClose() {
		this.setState({
			isaction: false
		})
	}


	postModal() {
		const me = this;
		const {
			user,
			projectid,
			groupname,
			groupid,
			edit_type,
			subject_id,
			subject_name,
			subject_age,
			subject_gender,
			subject_explain,
			subject_uid,
			subject_userid,
			tagids,
			tagname
		} = me.state;
		let postdata = '';
		let url = config.host + '/project_group/index';
		if (edit_type === 'editgroup') {
			postdata = {
				userid: user.id,
				company_id: user.company_id,
				projectid: projectid,
				groupid: groupid,
				groupname: groupname,
				Authorization: localStorage.token,
				request: 'groupedit'
			};
		}
		if (edit_type === 'editsubject') {
			url = config.host + '/project_subject/index';
			postdata = {
				userid: user.id,
				projectid: projectid,
				groupid: groupid,
				subject_id: subject_id,
				subject_name: subject_name,
				subject_gender: subject_gender,
				subject_age: subject_age,
				subject_explain: subject_explain,
				subject_uid: subject_uid,
				Authorization: localStorage.token,
				post_type: 'edit'
			};
		}

		if (edit_type === 'tagsubject') {
			url = config.host + '/tags/index';
			postdata = {
				userid: user.id,
				subject_id: subject_id,
				subject_userid: subject_userid,
				tagids: tagids,
				tagname: tagname,
				Authorization: localStorage.token,
				request: 'tagsubject'
			};
		}
		fetch(url, {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				me.notify(json.message);
				if (json.status === 1) {

					me.setState({
						loading: false,
						ismodal: false,
						tagids: [],
						tagname: ''
					});
					if (edit_type === 'tagsubject') {
						me.reloadSubjectTags(json.data);
					} else {
						me.refreshGroup();
					}


				} else {
					me.setState({
						loading: false
					});
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}


	actionSubmit() {
		const me = this;
		const {
			user,
			projectid,
			groupname,
			groupid,
			edit_type,
			subject_id
		} = me.state;
		me.setState({
			loading: true
		});
		let postdata = '';
		let url = config.host + '/project_group/index';
		if (edit_type === 'removegroup') {
			postdata = {
				userid: user.id,
				projectid: projectid,
				groupid: groupid,
				Authorization: localStorage.token,
				request: 'groupremove'
			};
		}
		if (edit_type === 'removesubject') {
			url = config.host + '/project_subject/index';
			postdata = {
				userid: user.id,
				projectid: projectid,
				groupid: groupid,
				subject_id: subject_id,
				Authorization: localStorage.token,
				post_type: 'remove'
			};
		}
		fetch(url, {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(response);
				if (json.status === 1) {
					me.setState({
						loading: false,
						isaction: false
					});

					me.notify(json.message);
					me.refreshGroup();
					return;
				}
				me.setState({
					loading: false,
					isaction: false
				});
				me.notify(json.message);
			})
			.catch(function(error) {
				console.log(error);
			});
	}


	//download single subject's all files with 
	modalDownload(subject, type) { //subject, dicom/nifti
		console.log('开始zip打包');
		const me = this;
		let {
			user,
			projectid
		} = this.state;

		me.setState({
			loading: true,
			download_message: '正在打包...',
			ismodal_download: true
		});

		const postdata = {
			userid: user.id,
			subjectid: subject.id,
			projectid: projectid,
			companyid: user.company_id,
			Authorization: localStorage.token,
			request: 'download_' + type
		};

		fetch(config.host + '/download/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				me.setState({
					loading: false
				});
				if (json.status === 1 && json.downloadurl) {
					me.setState({
						loading: false,
						download_message: '点击下载',
						downloadurl: json.downloadurl
					});
				} else {
					me.setState({
						ismodal_download: false
					});
				}
				me.notify(json.message);
			})
			.catch(function(error) {
				console.log(error);
			});
	}



	download(downtype) {
		console.log('开始zip打包');
		const me = this;
		let {
			user,
			projectid,
			checked_subjects,
			data_type
		} = this.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}

		me.setState({
			loading: true,
			download_message: '正在打包' + checked_subjects.length + '项受试者文件...',
			ismodal_download: true
		});

		const postdata = {
			userid: user.id,
			subjects: checked_subjects,
			projectid: projectid,
			companyid: user.company_id,
			data_type: data_type,
			Authorization: localStorage.token,
			request: downtype
		};

		fetch(config.host + '/download/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				me.setState({
					loading: false
				});
				if (json.status === 1 && json.downloadurl) {
					me.setState({
						loading: false,
						download_message: '点击下载',
						downloadurl: json.downloadurl
					});
				} else {
					me.setState({
						ismodal_download: false
					});
				}
				me.notify(json.message);
			})
			.catch(function(error) {
				console.log(error);
			});

	}


	change_group() {
		const me = this;
		let {
			groups,
			checked_subjects,
			changegroupid
		} = this.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}

		if (groups.length < 2) {
			me.notify('没有可以更换的分组');
			return;
		}

		me.setState({
			ismodal_changegroup: true
		});
	}

	radiogroups(groupid) {
		this.setState({
			changegroupid: groupid
		});
	}


	changeGroup() {
		console.log('开始更换分组');
		const me = this;
		let {
			user,
			projectid,
			groups,
			checked_subjects,
			changegroupid
		} = this.state;

		if (!checked_subjects.length) {
			me.notify('没有选择受试者');
			return;
		}

		if (groups.length < 2) {
			me.notify('没有可以更换的分组');
			return;
		}

		if (changegroupid == 0 || changegroupid == '') {
			me.notify('请选择要更换的分组');
			return;
		}

		me.notify('正在更换' + checked_subjects.length + '项受试者文件...');
		me.setState({
			loading: true
		});
		const postdata = {
			userid: user.id,
			subjects: checked_subjects,
			changegroupid: changegroupid,
			projectid: projectid,
			companyid: user.company_id,
			Authorization: localStorage.token,
			request: 'change_group'
		};

		console.log(postdata)
		fetch(config.host + '/project_group/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				console.log(json);
				me.setState({
					loading: false,
					ismodal_changegroup: false,
					checked_subjects: [],
					changegroupid: 0
				});
				me.notify(json.message);

				if (json.status === 1) {
					me.props.onInitial();
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}


	getPrototype() {
		const me = this;
		const {
			user
		} = me.state;
		const postdata = {
			level: user.level,
			companyid: user.company_id,
			userid: user.id,
			request: 'prototype',
			Authorization: localStorage.token
		};
		fetch(config.host + '/summary/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				if (json.status === 1) {
					const data = json.data;
					console.log(data);
					data.push('other');
					me.setState({
						prototype: data
					});
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	render() {
		const me = this;
		const {
			loading,
			tasks,
			data_type,
			download_message,
			downloadurl,
			projectid,
			pathurl,
			uistyle,
			groups
		} = me.state;
		//console.log(groups)
		return (
			<div className="my-3 pb-3 groups">
				<Loading display={loading} />

				{
					tasks.length > 0 && 
							<div className="text-right text-muted alert alert-warning">
								上传文件正在处理 <a className="cursor ml-3" onClick={me.sync}><i className="fa fa-sync"></i></a>
							</div>
				}

				{
					groups.length === 0 && <p className="text-center text-muted py-5 my-5 shadow-sm">请先创建分组</p>
				}

				{
					groups.length > 0 &&
					groups.map((group, key) => {
						let group_prototype = [];
						//console.log(data_type)
						//console.log(group.subjects)
						if(group.subjects.total > 0){
							group.subjects.data.map((item, i) => {
								if (data_type == 0 && item.series.length) {
										item.series.forEach(iseries => {
											if (!group_prototype.includes(iseries)) group_prototype.push(iseries);
										})
									}
								});
						} 
						return (
							<div className="card_list" key={key}>
								<div className="clearfix p-2">
									<div className="custom-control custom-checkbox float-left">
										<input type="checkbox" className="custom-control-input" id={'group_' + group.id} checked={group.checked} onChange={() => this.checkgroup(group.id)} />
										<label className="custom-control-label" htmlFor={'group_' + group.id}><span className="h6 d-inline-block m-0 p-0">{group.name} </span>  <small> [ 共 {group.subjects.total || 0} 条 ] </small> </label>
									</div>
									
									<div className="px-2 cursor float-left pt-1" title="展开/收起" onClick={() => this.showsubject(group.id)}> {group.showsubjects && <i className="fa fa-caret-down fa-lg animated rubberBand"></i>} {!group.showsubjects && <i className="fa fa-caret-right fa-lg animated rubberBand"></i>}</div>

									<div className="float-right pt-1">
										<Dropdown direction="dropleft">
											<div>
												<i className="fa fa-ellipsis-v text-muted px-2"></i>
											</div>
											<div>
												<div className="dropdown-header">操作菜单</div>
												<div className="dropdown-item cursor" onClick={() => { this.modalGroup(group) }}>修改分组</div>
												<div className="dropdown-divider"></div>
												<div className="dropdown-item cursor text-danger" onClick={() => { this.removeGroup(group.id) }}>删除</div>
											</div>
										</Dropdown>
									</div>

									<div className="float-right px-2 pt-1">
										<Link to={`/console/upload_subject/${me.state.projectid}/${group.id}/0`} className="btn btn-warning btn-xs"><i className="fa fa-plus-circle"></i> 添加受试者</Link>
									</div>
								</div>

								<table className="table">
									<thead>
										<tr>
											<th width="32%">受试者</th>
											{data_type !== 'archive' && uistyle.is_subjectuid && <th width="10%">UID</th> }
											<th width="15%">创建时间</th>
											{data_type !== 'archive' && <th width="20%">模态</th> }
											{data_type !== 'archive' && <th>标签</th> }
											<th className="text-right">操作</th>
										</tr>
									</thead>
									<tbody>
										{
											data_type !== 'archive' && group.showsubjects && group.subjects.total > 0 && group.subjects.data.map((item, i) => {
												return (
													<Subject key={i} data={{ prototype: group_prototype, subject: item, projectid: projectid, data_type: data_type, pathurl: pathurl, uistyle:uistyle, groupid:group.id }} checksubject={this.checksubject.bind(this)} modalSubject={this.modalSubject.bind(this)} modalDownload={this.modalDownload.bind(this)} removeSubject={this.removeSubject.bind(this)}
													/>
												);
											})
										}
										{
											data_type == 'archive' && group.showsubjects && group.subjects.total > 0 && group.subjects.data.map((item, i) => {
												return (
													<SubjectArchive key={i} data={{ subject: item, projectid: projectid, data_type: data_type, pathurl: pathurl }} checksubject={this.checksubject.bind(this)} modalSubject={this.modalSubject.bind(this)} modalDownload={this.modalDownload.bind(this)} removeSubject={this.removeSubject.bind(this)}
													/>
												);
											})
										}
									</tbody>
								</table>
							</div>
						)
					})
				}


				<div className="px-3 mt-3 mb-5 text-right">
					{
						data_type !== 'archive' && <button type="button" className="btn btn-primary btn-sm" onClick={() => { this.download('download_subjects') }}><i className="fa fa-download"></i> 批量下载</button>
					}
					{
						data_type === 'archive' && <button type="button" className="btn btn-primary btn-sm" onClick={() => { this.download('download_archive') }}><i className="fa fa-download"></i> 批量下载</button>
					}

					{
						data_type !== 'archive' && <button type="button" className="btn btn-info btn-sm ml-3" onClick={() => { this.change_group() }}><i className="fa fa-people-carry"></i> 更换分组</button>
					}
				</div>

				<Modal title={this.state.modaltitle} display={this.state.ismodal} close={this.modalClose} submit={this.modalSubmit}>
					{
						this.state.edit_type === 'editgroup' && <div className="form-group row">
							<label className="col-sm-2 col-form-label text-right">分组名称：</label>
							<div className="col-sm-10">
								<input type="text" className="form-control" placeholder="Group Name ..." name="groupname" value={this.state.groupname} onChange={this.handleInputChange} autoFocus="autofocus" maxLength="60" />
							</div>
						</div>
					}

					{
						this.state.edit_type === 'editsubject' && <Editsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
					}

					{
						this.state.edit_type === 'tagsubject' && <Tagsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
					}
				</Modal>

				<Modal title='提醒' display={this.state.ismodal_download} close={this.modalClose} submit={this.modalClose} hidefooter="true">
					<div className="text-center">
						{
							downloadurl === '' && <span>{download_message}</span>
						}
						{downloadurl !== '' && <a className="btn btn-primary my-3" target="_blank" href={downloadurl}><i className="fa fa-download"></i> {download_message}</a>}
					</div>
				</Modal>


				<Modal title='选择要更换的分组' display={this.state.ismodal_changegroup} close={this.modalClose} submit={this.changeGroup}>
				{
					this.state.groups.map((group, key) => {
						return(
								<div className="form-check  form-check-inline" key={key}>
									<input className="form-check-input" type="radio" name="exampleRadios"  id={'radiogroup_' + group.id} value="option1"  onChange={() => this.radiogroups(group.id)} />
								  <label className="form-check-label" htmlFor={'radiogroup_' + group.id}>
								    {group.name}
								  </label>
								</div>
							)
					})
				}
					
				</Modal>

				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item text-danger" onClick={this.actionSubmit}>删除</li>
						<li className="list-group-item" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/project_group.js